/**
 * @author chargoyao
 * @property placeholder {string} placeholder string
 * @property inputContainerStyle {object} input container element styles
 * @property placeholderStyle {object} placeholder container style
 * @property iconStyle {object} arrow icon style
 * @property options {array} options data array. in this array, label property is required.
 * @property initValue {number}
 * @property rootStyles {obj} root element styles
 * {lable: 'xxxxx', ......}
 */
import React, {Component} from 'react';

// css
import './customSelect.css';

class CustomSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ifMenuShow: false,
      ifShowPlaceholder: true,
      optionText: '',
      searchText: ''
    }
    this.throttle = true;
  }
  componentDidMount () {
    document.addEventListener('click', () => {
      this.clearMenu();
    }, false);
    this.props.options.forEach((item) => {
      item.options.forEach((opt) => {
        if (opt.value === this.props.initValue) {
          this.setState({
            optionText: opt.label,
            ifShowPlaceholder: false,
          })
        }
      })
    });
  }
  componentWillReceiveProps(nextProps) {
      nextProps.options.forEach((item) => {
        item.options.forEach((opt) => {
          if (opt.value === nextProps.initValue) {
            this.setState({
              optionText: opt.label,
              ifShowPlaceholder: false,
            })
          }
        })
      });
  }
  componentWillUnmount () {
    document.removeEventListener('click', () => {
      this.clearMenu();
    }, false)
  }
  clearMenu () {
    this.setState({
      ifMenuShow: false
    })
  }
  handleSelectControl (e) {
    e.nativeEvent.stopImmediatePropagation();
    this.setState({
      ifMenuShow: true
    });
    this.refs.customInput.focus();
  }
  handleSelectItem (e, opt) {
    e.nativeEvent.stopImmediatePropagation();
    this.setState({
      ifShowPlaceholder: false,
      optionText: opt.label,
      ifMenuShow: false,
      searchText: '' // clear active
    }, () => {
      this.refs.customInput.value = ''
    });
    this.props.onChange(opt);
  }
  handleKeyUp () {
    this.setState({
      ifShowPlaceholder: false,
      optionText: '',
      searchText: this.refs.customInput.value
    }, () => {
      this.getPosition();
    });

  }
  getPosition () {
    let obj = [];
    for (let i=0; i < this.props.options.length;i++) {
      if (this.refs[`searchList${i}`].className === 'active') {
        obj.push(i)
      }
    }
    if (obj.length > 0) {
      for (let i = 0; i <= obj[0]; i++) {
        if (i === 0) {
          this.refs.selectMenu.scrollTop = 0;
        } else {
          this.refs.selectMenu.scrollTop += this.refs[`searchList${i-1}`].clientHeight;
        }
      }
    }

  }
  render () {
    return (
      <div className="custom-select" style={this.props.rootStyles}>
        <div className="custom-select-control" style={{...this.props.inputContainerStyle}} onClick={(e) => this.handleSelectControl(e)}>
          {
            this.state.ifShowPlaceholder && (
              <div className="custom-select-placeholder" style={this.props.placeholderStyle}>
                {this.props.placeholder}
              </div>
            )
          }
          {
            !this.state.ifShowPlaceholder && (
              <div className="custom-select-text">
                {this.state.optionText}
              </div>
            )

          }


          <input type="text" className="custom-input" ref="customInput" onKeyUp={() => this.handleKeyUp()}/>
          <span className="Select-arrow-zone pull-right"><span className="Select-arrow"></span></span>
          {/*
          <ArrowDown
            style={{...iconInitStyle, ...this.props.iconStyle}}
          />*/}
        </div>
        {
          this.state.ifMenuShow && (
            <ul className="custom-select-menu" ref="selectMenu">
              {this.props.options.map((item, index) => (
                <li key={index} className={(this.state.searchText !== '' && new RegExp(this.state.searchText, "gi").test(item.label)) ? 'active' : ''} ref={`searchList${index}`}>
                  <h3 >{item.label}</h3>
                  <div className="custom-sub-options">
                    {
                      item.options.map((opt) => (
                        <section key={opt.value} onClick={(e) => this.handleSelectItem(e, opt)}>{opt.label}</section>
                      ))
                    }
                  </div>
                </li>
              ))}

            </ul>
          )
        }

      </div>
    )
  }
}

export default CustomSelect;


// WEBPACK FOOTER //
// ./src/components/framework/CustomSelect/CustomSelect.jsx